import compareBlocks from '@/utils/material/section/compareBlocks';
import { Workspace, blockCodeEditorSerializer } from '@cna-br/astro-code';
import { isEmpty } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useChangeWorkspace = (
  workspaceJson?: object,
  onChange?: (workspace: Workspace) => void,
) => {
  const [workspace, setWorkspace] = useState<Workspace>();

  const finishedLoading = useRef(false);

  const onWorkspaceChange = useCallback(
    (workspaceChange: Workspace) => {
      setWorkspace(workspaceChange);
      if (finishedLoading.current) {
        const currentTeacherCode =
          blockCodeEditorSerializer.save(workspaceChange);
        if (compareBlocks(currentTeacherCode, workspaceJson)) return;
        onChange?.(workspaceChange);
      }
    },
    [workspaceJson, onChange],
  );
  useEffect(() => {
    function changeListener(e: { type: string }) {
      if (e.type === 'finished_loading') {
        finishedLoading.current = true;
      }
    }
    if (!workspaceJson) {
      finishedLoading.current = true;
    }
    if (!isEmpty(workspaceJson) && workspace) {
      if (workspace.getAllBlocks().length > 1) return;
      blockCodeEditorSerializer.load(workspaceJson, workspace);
      workspace.addChangeListener(changeListener);
    }
    return () => {
      if (workspace) workspace.removeChangeListener(changeListener);
    };
  }, [workspace, workspaceJson]);

  return { workspace, onWorkspaceChange };
};

export const useWorkspace = (workspaceJson?: object) => {
  const [workspace, setWorkspace] = useState<Workspace>();

  useEffect(() => {
    if (workspaceJson && workspace) {
      blockCodeEditorSerializer.load(workspaceJson, workspace);
    }
  }, [workspaceJson, workspace]);

  return { workspace, setWorkspace };
};
